import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import icon from '../assets/icon.png';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const Header: React.FC = () => {
  const fullLocation = useLocation();
  const pathName = fullLocation.pathname.replace('/deckhopper', '');
  console.log(pathName);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const loadGTM = (id: string) => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); }
      window.gtag('js', new Date());
      window.gtag('config', id);

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(script);
    }
    loadGTM('G-CBP2P2ZB0M');
  }, []);

  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>Deck Hopper - Your Ultimate Deck App</title>
          <meta name="description" content="Deck Hopper is a powerful Deck App for SAMMI Solutions." />
          <meta name="keywords" content="deck hopper, sammi, deck app, streaming" />
          <meta name="author" content="Christina K." />
        </Helmet>
        <div className="flex justify-center">
        <header className="bg-[#122c52] text-gray-300 p-4 w-full max-w-[100em]  fixed m-auto z-50">
          <div className="relative mx-auto flex max-w-7xl items-center justify-between lg:grid lg:grid-cols-3 lg:h-[65px]">
            {/* Left Navigation Menu */}
            <div className="hidden lg:flex lg:items-center lg:space-x-6">
              <nav aria-label="Main">
                <ul className="flex space-x-3">
                  <li>
                    <Link
                      to="/home"
                      className={`flex items-center rounded-full py-1 px-4 font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                        pathName === "/home" ? "bg-gray-500/30 text-primary-light" : ""
                      }`}>
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/features"
                      className={`flex items-center rounded-full py-1 px-4  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                        pathName === "/features" ? "bg-gray-500/30 text-primary-light" : ""
                      }`}>
                      Features
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/setup"
                      className={`flex items-center rounded-full py-1 px-4  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                        pathName === "/setup" ? "bg-gray-500/30 text-primary-light" : ""
                      }`}>
                      Setup
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/faq"
                      className={`flex items-center rounded-full py-1 px-4  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                        pathName === "/faq" ? "bg-gray-500/30 text-primary-light" : ""
                      }`}>
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/troubleshooting"
                      className={`flex items-center rounded-full py-1 px-4  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                        pathName === "/troubleshooting" ? "bg-gray-500/30 text-primary-light" : ""
                      }`}>
                      Help
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* Center Logo */}
            <div className="flex justify-center items-center">
              <Link to="/home" className="flex items-center gap-3">
                <img src={icon} alt="Deck Hopper Icon" className="h-10 w-10" />
                <span className="text-2xl  block lg:hidden xl:block">Deck Hopper</span>
              </Link>
            </div>

            {/* Right Navigation Menu and Download Button */}
            <div className="hidden lg:flex lg:items-center lg:space-x-2 justify-end">
              <nav aria-label="Secondary">
                <ul className="flex space-x-3">
 
                  <li>
                    <Link
                      to="/upgrade"
                      className="flex items-center rounded-md px-4 py-2 font-medium bg-purple-600 text-white hover:bg-purple-700 transition">
                      Upgrade to Pro
                    </Link>
                  </li>
                </ul>
              </nav>
              {/* Download Button */}
              <Link to="/download">
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition  font-medium">
                  Download
                </button>
              </Link>
            </div>

            {/* Hamburger Menu Button for Mobile */}
            <div className="lg:hidden">
              <button
                className="text-gray-300 focus:outline-none"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                aria-label="Toggle mobile menu"
              >
                {isMobileMenuOpen ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Mobile Navigation Menu */}
          {isMobileMenuOpen && (
            <nav className="lg:hidden mt-4">
              <ul className="flex flex-col space-y-2 items-center bg-[#122c52] p-4">
                <Link
                  to="/home"
                  className={`w-full text-center py-2 rounded  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                    pathName === "/home" ? "bg-gray-500/30 text-primary-light" : ""
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}>
                  Home
                </Link>
                <Link
                  to="/features"
                  className={`w-full text-center py-2 rounded  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                    pathName === "/features" ? "bg-gray-500/30 text-primary-light" : ""
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}>
                  Features
                </Link>
                <Link
                  to="/setup"
                  className={`w-full text-center py-2 rounded  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                    pathName === "/setup" ? "bg-gray-500/30 text-primary-light" : ""
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}>
                  Setup
                </Link>
                <Link
                  to="/faq"
                  className={`w-full text-center py-2 rounded  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                    pathName === "/faq" ? "bg-gray-500/30 text-primary-light" : ""
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}>
                  FAQ
                </Link>
                <Link
                  to="/troubleshooting"
                  className={`w-full text-center py-2 rounded  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                    pathName === "/troubleshooting" ? "bg-gray-500/30 text-primary-light" : ""
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}>
                  Help
                </Link>
                <Link
                  to="/patch-notes"
                  className={`w-full text-center py-2 rounded  font-medium transition-colors hover:bg-gray-500/30 hover:text-primary-light ${
                    pathName === "/patch-notes" ? "bg-gray-500/30 text-primary-light" : ""
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}>
                  Patch Notes
                </Link>
                <Link
                  to="/upgrade"
                  className="w-full text-center py-2 rounded  font-medium bg-[#a9349e] text-white hover:bg-[#8c2783] transition"
                  onClick={() => setIsMobileMenuOpen(false)}>
                  Upgrade to Pro
                </Link>
                <Link
                  to="/download"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="w-full">
                  <button className="w-full px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition  font-medium">
                    Download
                  </button>
                </Link>
              </ul>
            </nav>
          )}
        </header>
      </div>
      </div>
    </HelmetProvider>
  );
};

export default Header;
